import React, { useEffect, useRef } from "react";
import { loadPayPalScript } from "./paypalSdkLoader";
import "./PayPalSubscriptionButton.css";

import appSettings from "../../data/appSettings";

const CustomPayPalSubscriptionButton = ({
  paypalClientId,
  paypalPlanId,
  quantity,
  email,
  firstName,
  lastName,
  licenseType,
  onClick,
  onSuccess,
  onError,
}) => {
  const retryFetchIfNetworkError = async (
    url,
    options,
    retries = 3,
    baseDelay = 1000,
  ) => {
    for (let attempt = 0; attempt < retries; attempt++) {
      try {
        return await fetch(url, options);
      } catch (err) {
        const msg = (err && err.message) || "";
        const isNetworkError =
          err instanceof TypeError ||
          /failed to fetch|network|networkerror/i.test(msg);
        if (!isNetworkError || attempt === retries - 1) throw err;
        await new Promise((res) => setTimeout(res, baseDelay * (attempt + 1)));
      }
    }
  };

  const paypalRef = useRef(null);
  useEffect(() => {
    if (!paypalClientId || !paypalPlanId || !paypalRef.current) return;

    // Clear any previously rendered PayPal button
    paypalRef.current.innerHTML = "";

    loadPayPalScript(paypalClientId)
      .then((paypal) => {
        paypal
          .Buttons({
            style: {
              layout: "vertical",
              color: "blue",
              shape: "rect",
              label: "subscribe",
            },
            createSubscription: function (data, actions) {
              return actions.subscription.create({
                plan_id: paypalPlanId,
                quantity: quantity.toString(),
              });
            },
            onApprove: async function (data, actions) {
              //console.log("Paypal Subscription approved:", data);
              onClick?.();
              try {
                const res = await retryFetchIfNetworkError(
                  appSettings.WEBPURCHASE_API_URL,
                  {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      paypal_subscription_id: data.subscriptionID,
                      email,
                      first_name: firstName,
                      last_name: lastName,
                      license_type: licenseType,
                    }),
                  },
                  3,
                );

                if (!res.ok) {
                  throw new Error(
                    `Failed to generate license for subscription ${data.subscriptionID}. Please contact support for assistance.`,
                  );
                }
                onSuccess?.(data);
              } catch (err) {
                console.error(err);
                onError?.(err);
              }
            },
            onCancel: function () {
              console.log("User has cancelled subscription process.");
              onError?.({
                message: "User has cancelled subscription process.",
              });
            },
            onError: function (err) {
              console.error("PayPal error:", err);
              onError?.(err);
            },
          })
          .render(paypalRef.current);
      })
      .catch((err) => {
        console.error("PayPal SDK Load Error:", err);
      });
  }, [
    paypalClientId,
    paypalPlanId,
    quantity,
    email,
    firstName,
    lastName,
    licenseType,
    onClick,
    onSuccess,
    onError,
  ]);

  return <div ref={paypalRef} className="paypal-button-container" />;
};

export default CustomPayPalSubscriptionButton;
